import PropTypes from 'prop-types';

import Box from '@mui/material/Box';

import { useBoolean } from 'src/hooks/use-boolean';

import Main from "./main";
import Header from './header';
import Footer from "./footer";
import NavMini from "./nav-mini";
import NavVertical from './nav-vertical';
import {useResponsive} from "../../hooks/use-responsive";
import {useSettingsContext} from "../../components/settings/index";
import InstallGuideSheet from "../../sections/install-guide/install-guide-sheet";

// ----------------------------------------------------------------------

export default function DashboardLayout({ children }) {
  const settings = useSettingsContext();

  const lgUp = useResponsive('up', 'lg');
  const smDown = useResponsive('down', 'sm');

  const nav = useBoolean();

  const isMini = settings.themeLayout === 'mini';

  const renderNavMini = <NavMini />;

  const renderNavVertical = <NavVertical openNav={nav.value} onCloseNav={nav.onFalse} />;

  if (isMini) {
    return (
      <>
        <Header onOpenNav={nav.onTrue} />

        <Box
          sx={{
            minHeight: 1,
            display: 'flex',
            flexDirection: { xs: 'column', lg: 'row' },
          }}
        >
          {lgUp ? renderNavMini : renderNavVertical}

          <Main>{children}</Main>
        </Box>

        <InstallGuideSheet />
      </>
    );
  }

  return (
    <>
      <Header onOpenNav={nav.onTrue} />

      <Box
        sx={{
          minHeight: 1,
          display: 'flex',
          flexDirection: { xs: 'column', lg: 'row' },
        }}
      >
         {renderNavVertical}

         <Main>{children}</Main>
      </Box>

      {smDown && <Footer />}

      <InstallGuideSheet />
    </>
  );
}

DashboardLayout.propTypes = {
  children: PropTypes.node,
};
